import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";
import React, { useContext } from "react";
import { View } from "../../../components/shared/Themed";
import Colors from "../../../utils/constants/colors";
import useColorScheme from "../../../hooks/useColorScheme";
import TabBarIcon from "../../../components/core/TabBarIcon";
import ProfileScreen from "../../../screens/Settings/UserSettingScreens/UserSettingProfileScreen";
import LoginScreen from "../../../screens/Settings/UserSettingScreens/UserSettingLoginScreen";
import { RootTabParamList, RootTabScreenProps } from "../../../types";
import DeviceOrientationContext from "../../../components/context/DeviceOrientationContext";
import UserSettingNotificationScreen from "../../../screens/Settings/UserSettingScreens/UserSettingNotificationScreen";
import CompanyLogo from "../../../components/core/CompanyLogo";
import { TouchableOpacity } from "react-native";
import oktaConfig from "../../../configs/okta";
import { useTranslation } from "../../../utils/useTranslation";

const Tab = createMaterialTopTabNavigator<RootTabParamList>();

export default function UserSettingsTabNavigator({ navigation }: any) {
  const { t } = useTranslation();
  const colorScheme = useColorScheme();
  const orientationContext = useContext(DeviceOrientationContext);
  const { isSmallDevice } = useContext(DeviceOrientationContext);

  return (
    <View
      style={{
        height: "100%",
        backgroundColor: colorScheme === "light" ? "#fafafa" : "#fafafa",
      }}
    >
      {!isSmallDevice && (
        <View style={{ flexDirection: "row", width: "100%", height: 60 }}>
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              width: "40%",
              height: 60,
            }}
          >
            <CompanyLogo />
          </View>
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              width: "60%",
              height: 60,
            }}
          >
            <TouchableOpacity
              onPress={() =>
                navigation.navigate("Root", {
                  screen: "Home",
                })
              }
            >
              <TabBarIcon name="home" color={"black"} />
            </TouchableOpacity>
          </View>
        </View>
      )}
      <Tab.Navigator
        initialRouteName="Profile"
        screenOptions={{
          tabBarActiveTintColor: Colors[colorScheme].tint,
          tabBarStyle: {
            display: "none",
            height: 50,
            width: "100%",
            alignSelf: "center",
            justifySelf: "center",
            borderTopWidth: 0,
            backgroundColor: colorScheme === "light" ? "#fafafa" : "#fafafa",
          },
          tabBarLabelStyle: {
            fontSize: 14,
            fontWeight: "bold",
            textTransform: "none",
          },
          tabBarItemStyle: {
            flex: 1,
          },
        }}
      >
        <Tab.Screen
          name="Profile"
          component={ProfileScreen}
          options={({ navigation }: RootTabScreenProps<"Profile">) =>
            orientationContext.isSmallDevice
              ? {
                title: "",
                tabBarIcon: ({ color }) =>
                  orientationContext.isSmallDevice && (
                    <TabBarIcon name="user-circle" color={color} />
                  ),
              }
              : {
                title: t("profile"),
              }
          }
        />
        <Tab.Screen
          name="ChangePassword"
          component={LoginScreen}
          options={({ navigation }: RootTabScreenProps<"Login">) =>
            orientationContext.isSmallDevice
              ? {
                title: "",
                tabBarIcon: ({ color }) =>
                  orientationContext.isSmallDevice && (
                    <TabBarIcon name="key" color={color} />
                  ),
              }
              : {
                title: t("multistepsGo"),
              }
          }
        />
        <Tab.Screen
          name="Notification"
          component={UserSettingNotificationScreen}
          options={({
            navigation,
          }: RootTabScreenProps<"UserSettingNotificationScreen">) =>
            orientationContext.isSmallDevice
              ? {
                title: "",
                tabBarIcon: ({ color }) =>
                  orientationContext.isSmallDevice && (
                    <TabBarIcon name="bell" color={color} />
                  ),
              }
              : {
                title: t("notification"),
              }
          }
        />
      </Tab.Navigator>
    </View>
  );
}
